<template>
  <div :class="isHome ? 'pos-home' : 'pos-other'" @mouseleave="mouseleave()">
    <div class="home-menu" :style="isHome ? 'pos-home' : 'margin-bottom: 25px;'">
      <swiper class="myMenu" :options="swiperOption" :not-next-tick="notNextTick" ref="menu">
        <!-- slides -->
        <swiper-slide class="item" v-for="item of navData.filter(o=> !o.PARENTID)" :key="item.ID">
          <div :class="item.NAVPAGE == nowurl? 'itembox is-hover' : 'itembox'"
               @mouseover="mouseover(item.NAVPAGE,item.ID)"
               @click="toPage(item.NAVPAGE, item.ID)">
            <div class="s-img">
              <i :class="item.NAVICON !== '' ? 'icon iconfont ' + item.NAVICON : 'el-icon-s-order'"></i>
            </div>
            <div class="s-info">
              <div class="s-ti">{{ item.NAVNAME }} <span class="gobtn">GO<i class="icon el-icon-arrow-right"></i></span></div>
              <div class="s-decr">{{ item.NAVDESC }}</div>
            </div>
          </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-button-prev" slot="button-prev" v-show="navData.filter(o=> !o.PARENTID).length > 6"><i class="el-icon-arrow-left"></i></div>
        <div class="swiper-button-next" slot="button-next" v-show="navData.filter(o=> !o.PARENTID).length > 6"><i class="el-icon-arrow-right"></i></div>
      </swiper>
    </div>
    <div class="home-menu next-menu" v-show="isActive && navData.filter(o=> o.PARENTID == navId).length > 0">
      <div class="child-menu">
        <div class="item"
             v-for="item of navData.filter(o=> o.PARENTID == navId)"
             :class="item.NAVPAGE === $route.path? 'active':''"
             @click="toPage(item.NAVPAGE, item.ID)">
          {{ item.NAVNAME }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isHome: { type: Boolean, default: false },
  },
  data() {
    return {
      notNextTick: false,
      swiperOption: {
        mousewheelControl: false,
        observeParents: true,
        slidesPerView: 6,
        spaceBetween: 0,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
      },
      nowurl:this.$route.path,
      navId: "",
      twoID: "",
      navData: [],
      isActive: false,
    }
  },
  watch: {
    $route(to, from) {
      this.load();
    },
  },
  computed: {
    swiper() {
      return this.$refs.menu.swiper
    }
  },
  methods: {
    load: function () {
      this.nowurl = this.$route.path;
      // this.twoID = this.$route.query.id;
      // const parentID = this.$fun.getCacheNav().filter(o => o.ID == this.$route.query.id)[0].PARENTID;
      // if (this.$route.query.id !== parentID && parentID !== null) {
      //   this.navId = this.$fun.getCacheNav().filter(o => o.ID == this.$route.query.id)[0].PARENTID;
      // }else{
      //   this.navId = this.$route.query.id;
      // }
    },
    mouseover(url,id) {
      this.nowurl = url;
      this.navId = id;
      this.isActive = true;
    },
    mouseleave() {
      // if(this.$route.query.id){
      //   const parentID = this.$fun.getCacheNav().filter(o => o.ID == this.$route.query.id)[0].PARENTID;
      //   if (this.$route.query.id !== parentID && parentID !== null) {
      //     this.navId = this.$fun.getCacheNav().filter(o => o.ID == this.$route.query.id)[0].PARENTID;
      //   }else{
      //     this.navId = this.$route.query.id;
      //   }
      // }else{
      //   this.navId = "";
      // }
      this.navId = "";
      this.nowurl = this.$route.path;
      this.isActive = false;
    },
    toPage(url, id) {
      this.nowurl = url;
      if (!url) {
        return;
      }
      if (url[0] == "/") {
        this.$router.push(url);
        return;
      }
      window.open(url);
    }
  },
  mounted: function () {
    // this.load();
    if(window.localStorage.HDSWebNav){
      this.navData = this.$fun.getCacheNav();
      return;
    }
    this.$bti.GetNavList({ ORGID: this.$com.orgId(), NAVPORT: 2 }).then((res) => {
        if (res.code == -1) {
          return;
        }
        this.navData=res.data;
    });
  }
}
</script>

<style lang="css" scoped>
.home-menu {
  background-color: #fff;
  padding: 15px 10px;
  border-radius: 10px;
  /*box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.102);*/
  /*-webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.102);*/
  /*-o-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.102);*/
  /*-moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.102);*/
}

.swiper-button-prev,
.swiper-button-next {
  background-image: none;
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #000;
  font-weight: bold;
  font-size: 24px;
  cursor: pointer;
  margin-top: 0;
  top: 5px;
}

.swiper-button-prev {
  left: 0;
  text-align: left;
}

.swiper-button-next {
  right: 0;
  text-align: right;
}

.home-menu .myMenu .item .itembox {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
}

.s-img {
  background-color: #F3F5F7;
  border-radius: 5px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-right: 10px;
}

.s-img .icon {
  font-size: 16px;
}

.s-img .el-icon-s-order {
  font-size: 20px;
}

.s-info .s-ti {
  font-weight: bold;
  margin-bottom: 5px;
}

.gobtn {
  display: none;
  font-size: 12px;
  background-color: #FF6000;
  color: #fff;
  font-weight: normal;
}

.s-decr {
  width: 101px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #B8B8B8;
}

.child-menu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: start;
}

.child-menu {
  padding: 0px 20px;
}

.child-menu .item {
  margin-right: 30px;
  padding: 0px 15px;
  height: 25px;
  line-height: 25px;
  background-color: #eee;
  border-radius: 30px;
  cursor: pointer;
  color: #000;
}

.child-menu .item.active,
.child-menu .item:hover {
  background-color: #3C9B9E;
  color: #fff;
}

.myMenu .item .is-hover .s-img {
  background-color: #3C9B9E;
  color: #fff;
}

.myMenu .item .is-hover .s-ti {
  color: #3C9B9E;
}

.next-menu {
  position: absolute;
  top: 70px;
  width: 100%;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.102);
  -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.102);
  -o-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.102);
  -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.102);
  z-index: 11;
}

.pos-home {
  position: relative;
}

.pos-other {
  margin-top: 25px;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/common/NavView.vue